<template>
  <div style="margin-top: 20px">
    <div
      style="
        display: flex;
        font-size: 28px;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid black;
        background-color: #f7f7f7;
      "
    >
      <a href="#xmxx" :class="getDetailActive == 1 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 1"
          :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"
        >
          项目详细
        </div></a
      ><a href="#jysj" :class="getDetailActive == 2 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 2"
          :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'"
        >
          交易条件
        </div></a
      >
      <a href="#tpzs" :class="getDetailActive == 3 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 3"
          :class="getDetailActive == 3 ? 'getDetail' : 'getdetail'"
        >
          图片展示
        </div></a
      >
    </div>
    <div
      style="
        text-align: center;
        padding: 20px;
        padding-top: 40px;
        font-size: 24px;
      "
      class="conent"
    >
      <div style="border: 1px solid #fff">
        <div class="footerTitle" id="xmxx"></div>
        <div>
          <div class="fengexian">
            <el-divider content-position="center">转出方信息</el-divider>
          </div>
        </div>
        <div class="tableBox">
          <div class="left">
            <div class="tet">
              <div class="tet1">转出方类别:</div>
              <div class="tet2">
                {{ getDictValue(detail.economictype, "out_person_type") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">转出方名称:</div>
              <div class="tet2">
                {{ detail.outname || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">住所地址:</div>
              <div class="tet2">
                {{ detail.address || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">
                {{
                  detail.economictype == 6 || detail.economictype == 7
                    ? "身份证号"
                    : "法人身份证号"
                }}:
              </div>
              <div class="tet2">
                {{
                  (detail.idnum
                    ? detail.idnum.slice(0, 4) +
                      "**********" +
                      detail.idnum.slice(-4)
                    : "") || "/"
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">联系电话:</div>
              <div class="tet2">
                <span>{{
                  (detail.phone &&
                    (showPhone
                      ? detail.phone
                      : detail.phone.slice(0, 3) +
                        "*****" +
                        detail.phone.slice(-3))) ||
                  "/"
                }}</span>
                <img
                  src="../assets/img/closeEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  v-if="showPhone && cityDetail.cityName != '许昌市'"
                  @click="checkShowPhone"
                />
                <img
                  src="../assets/img/openEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  v-else-if="detail.phone && cityDetail.cityName != '许昌市'"
                  @click="checkShowPhone"
                />
              </div>
            </div>
            <div class="tet">
              <div class="tet1">邮箱:</div>
              <div class="tet2">
                {{ detail.email || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="detail.economictype != 6 && detail.economictype != 7"
            >
              <div class="tet1">统一社会信用代码:</div>
              <div class="tet2">
                <span>{{
                  (detail.registernum &&
                    (showRegisternum
                      ? detail.registernum
                      : detail.registernum.slice(0, 4) +
                        "**********" +
                        detail.registernum.slice(-4))) ||
                  "/"
                }}</span>
                <img
                  src="../assets/img/closeEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  v-if="showRegisternum"
                  @click="checkShowRegisternum"
                />
                <img
                  src="../assets/img/openEye.png"
                  style="width: 30px; height: 30px; cursor: pointer"
                  v-else-if="detail.registernum"
                  @click="checkShowRegisternum"
                />
              </div>
            </div>
            <div
              class="tet"
              v-if="detail.economictype != 6 && detail.economictype != 7"
            >
              <div class="tet1">注册资本:</div>
              <div class="tet2">
                {{ detail.registermoney || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="detail.economictype != 6 && detail.economictype != 7"
            >
              <div class="tet1">法定代表人:</div>
              <div class="tet2">
                {{ detail.realname || "/" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="border: 1px solid #fff">
        <div class="footerTitle" id="xmxx"></div>
        <div>
          <div class="fengexian">
            <el-divider content-position="center">
              {{ detail.number == 11 ? "项目信息" : "产权信息" }}</el-divider
            >
          </div>
        </div>
        <div class="tableBox">
          <div class="left">
            <div class="tet">
              <div class="tet1">项目名称:</div>
              <div class="tet2">
                {{ detail.projectname || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">坐落位置:</div>
              <div class="tet2">
                {{ detail.pid || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">预算金额(万元):</div>
              <div class="tet2">
                {{ detail.budgetAmount || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">资金来源:</div>
              <div class="tet2">
                {{ detail.amountSource || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">计划开工日期:</div>
              <div class="tet2">
                {{ detail.jobstarttime || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">计划完工日期:</div>
              <div class="tet2">
                {{ detail.jobstoptime || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">招标方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.invitationType, "invitation_type") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">数量:</div>
              <div class="tet2">
                {{ detail.area || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">单位:</div>
              <div class="tet2">
                {{ getDictValue(detail.areaUnit, "area_unit") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">转出金额:</div>
              <div class="tet2">
                {{
                  detail.price +
                    " 元/年/" +
                    getDictValue(detail.areaUnit, "area_unit") || "/"
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">项目类型:</div>
              <div class="tet2">
                {{ getDictValue(detail.projectAreaType, "project_area_type") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">农地权属:</div>
              <div class="tet2">
                {{ getDictValue(detail.soil, "land_type") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">承包方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.job, "job_type") }}
              </div>
            </div>
            <div class="tet" v-if="detail.number == 11">
              <div class="tet1">项目概述:</div>
              <div class="tet2">
                {{ detail.content || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">地力等级:</div>
              <div class="tet2">
                {{ detail.diji || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">东邻:</div>
              <div class="tet2">
                {{ detail.east || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">南邻:</div>
              <div class="tet2">
                {{ detail.south || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">西邻:</div>
              <div class="tet2">
                {{ detail.west || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">北邻:</div>
              <div class="tet2">
                {{ detail.north || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">涉及农户数:</div>
              <div class="tet2">
                {{ detail.peasantnum || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.number != 1">
              <div class="tet1">土地性质:</div>
              <div class="tet2">
                {{ getDictValue(detail.tdxz, "tdxz_type") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">交通:</div>
              <div class="tet2">
                {{ detail.traffic || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">地上物情况:</div>
              <div class="tet2">
                {{ detail.dswqk || "/" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="border: 1px solid #fff">
        <div class="footerTitle" id="xmxx"></div>
        <div>
          <div class="fengexian">
            <el-divider content-position="center"> 转出信息</el-divider>
          </div>
        </div>
        <div class="tableBox">
          <div class="left">
            <div class="tet" v-if="detail.rollout != 2">
              <div class="tet1">转出开始时间:</div>
              <div class="tet2">
                {{ detail.outstarttime || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.rollout != 2">
              <div class="tet1">转出结束时间:</div>
              <div class="tet2">
                {{ detail.outstoptime || "/" }}
              </div>
            </div>
            <div class="tet" v-if="detail.rollout != 2">
              <div class="tet1">流转期限（月）:</div>
              <div class="tet2">
                {{
                  this.detail.outstarttime &&
                  this.detail.outstoptime &&
                  (Number(this.detail.outstoptime.split("-")[0]) -
                    Number(this.detail.outstarttime.split("-")[0])) *
                    12 +
                    Number(this.detail.outstoptime.split("-")[1]) -
                    Number(this.detail.outstarttime.split("-")[1]) +
                    Number(
                      (
                        (Number(this.detail.outstoptime.split("-")[2]) -
                          Number(this.detail.outstarttime.split("-")[2])) /
                        30
                      ).toFixed(2)
                    )
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">转出方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.rollout, "out_type") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">支付方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.payment, "pay_type") }}
              </div>
            </div>
            <div class="tet" v-if="detail.payment == 6">
              <div class="tet1">分期次数:</div>
              <div class="tet2">
                {{ detail.times || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">保证金（元）:</div>
              <div class="tet2">
                {{
                  (cityDetail.cityName != "濮阳市华龙区" &&
                    cityDetail.cityName != "濮阳市清丰县" &&
                    detail.deposit) ||
                  "/"
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">出价幅度:</div>
              <div class="tet2">
                {{
                  getDictValue(
                    Number(detail.floatingPrice).toFixed(0),
                    "floating_price"
                  )
                }}
                元/年/{{ getDictValue(detail.areaUnit, "area_unit") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">是否再次转出:</div>
              <div class="tet2">
                {{ getDictValue(detail.twoout, "yes_no") }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">上次转出方式:</div>
              <div class="tet2">
                {{ detail.oneout || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">其他农户是否放弃优先权:</div>
              <div class="tet2">
                {{ getDictValue(detail.otherpeasant, "yes_no") }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">授权情况:</div>
              <div class="tet2">
                {{ detail.authorization || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">受让条件:</div>
              <div class="tet2">
                <span style="max-width: 100%; white-space: wrap"
                  >自然人需年满18周岁以上、70周岁以下具有完全民事行为能力。非失信人员。</span
                >
              </div>
            </div>
            <div class="tet">
              <div class="tet1">披露事项:</div>
              <div class="tet2">
                {{ detail.cracksevents || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">公示期（天）:</div>
              <div class="tet2">
                {{ detail.expire || "/" }}
              </div>
            </div>
            <div
              class="tet"
              v-if="
                detail.number != 10 && detail.number != 11 && detail.number != 8
              "
            >
              <div class="tet1">承包用途:</div>
              <div class="tet2">
                {{ detail.contractingpurpose || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">支付期限（天）:</div>
              <div class="tet2">
                {{ detail.paymentDateline || "/" }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">是否线上竞拍:</div>
              <div class="tet2">
                {{ getDictValue(detail.isOnline, "yes_no") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="border: 1px solid #fff">
        <div class="footerTitle" id="jysj"></div>
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">交易条件</el-divider>
          </div>
        </div>
        <div class="tableBox">
          <div class="left">
            <div class="tet">
              <div class="tet1">标的公告价格:</div>
              <div class="tet2">
                {{
                  detail.price +
                    " 元/年/" +
                    getDictValue(detail.areaUnit, "area_unit") || "/"
                }}
              </div>
            </div>
            <div class="tet">
              <div class="tet1">受让方应当具备的条件:</div>
              <div class="tet3">{{ detail.condition || "/" }}</div>
            </div>
            <div class="tet">
              <div class="tet1">合同付款支付方式:</div>
              <div class="tet2">
                {{ getDictValue(detail.payment, "pay_type") }}
              </div>
            </div>

            <div class="tet">
              <div class="tet1">其他需要披露的事项:</div>
              <div class="tet2">{{ detail.cracksevents || "/" }}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="footerTitle" id="tpzs"></div>
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">图片展示</el-divider>
          </div>
        </div>
        <div class="imgcontent">
          <el-image
            v-for="(item, index) in imgList"
            :key="index"
            style="
              width: 48%;
              height: auto;
              margin-left: 10px;
              margin-bottom: 10px;
            "
            :src="item"
            :preview-src-list="imgList"
          >
          </el-image>
        </div>
      </div>
      <div
        v-if="
          cityDetail.cityName == '濮阳市华龙区' ||
          cityDetail.cityName == '获嘉县' ||
          cityDetail.cityName == '濮阳市清丰县'
        "
      >
        <div class="footerTitle" id="tpzs"></div>
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">附件信息</el-divider>
          </div>
          <div style="display: flex">
            <div class="left" style="width: 100%; text-align: left">
              <div class="tet" style="width: 100%">
                <div class="tet1">交易公告:</div>
                <div class="tet2">
                  <a
                    v-if="detail.noticeFile"
                    :href="detail.noticeFile"
                    style="color: #00e; text-decoration: #00e underline"
                    download="交易公告扫描件"
                    >交易公告扫描件(点击下载)</a
                  >
                  <span v-else>暂无扫描件</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">竞买登记</el-divider>
          </div>
        </div>

        <table style="width: 100%" border="1">
          <tr>
            <th>投标方资格条件</th>
            <td></td>
          </tr>
          <tr>
            <th>报名方式</th>
            <td v-if="!applyWay">
              <p>1、意向受让方首次报名须知：</p>
              <p>
                ①企业法人单位组织须提交加盖公章的《营业执照》复印件等证明主体资格的相关材料以及法定代表人身份证复印件、经办人身份证复印件、授权委托书、公章、法人章等相关材料；
              </p>
              <p>
                ②非企业法人单位须提交以下资料：申请人身份证正反面复印件1份、申请人银行卡正反面复印件1份。
              </p>
              <p>
                2、非首次报名的意向受让方按时根据保证金备注要求交纳交易保证金后即可参与本期竞价。
              </p>
              <p>3、交易中心向意向受让方发放报价账号（长期有效、注意保管）。</p>
              <p>
                4、交易保证金交纳截止日当天17:30前未收到交易账号激活短信的意向受让方，请致电交易中心。
              </p>
            </td>
            <td v-else v-html="applyWay"></td>
          </tr>
          <tr>
            <th>保证金及处理方式</th>
            <td>
              <p style="font-weight: bold">
                1、须交纳的交易保证金金额为人民币{{
                  cityDetail.cityName != "濮阳市华龙区" &&
                  cityDetail.cityName != "濮阳市清丰县"
                    ? detail.deposit + " 元"
                    : ""
                }}。
              </p>
              <p style="font-weight: bold">
                2、开户行:{{
                  backCardInfo &&
                  cityDetail.cityName != "濮阳市华龙区" &&
                  cityDetail.cityName != "濮阳市清丰县"
                    ? backCardInfo.bankName
                    : ""
                }}
              </p>
              <p style="font-weight: bold">
                户名:{{
                  backCardInfo &&
                  cityDetail.cityName != "濮阳市华龙区" &&
                  cityDetail.cityName != "濮阳市清丰县"
                    ? backCardInfo.cardName
                    : ""
                }}
              </p>
              <p style="font-weight: bold">
                账号:{{
                  backCardInfo &&
                  cityDetail.cityName != "濮阳市华龙区" &&
                  cityDetail.cityName != "濮阳市清丰县"
                    ? backCardInfo.cardNo
                    : ""
                }}
              </p>
              <p>
                须在交纳保证金截止时间前电话通知交易中心已交纳保证金，如未通知或不得参与竞价。
              </p>
              <p>交纳交易保证金要求：</p>
              <p>
                ①交易保证金可选择网上银行转账、手机银行转账、银行柜面转账、线上支付方式提交。
              </p>
              <p>② 交纳交易保证金时，须备注相关信息：</p>
              <p>企业：项目名称+企业名称。例：XX项目XX公司保证金；</p>
              <p>个人：项目名称+姓名。例：XX项目XX保证金；</p>
              <p>
                交易保证金交易截止时间前未正确备注信息的，资格审查不予通过。
              </p>
              <p>
                未成交者的交易保证金交易中心将在交易结束后15个工作日内全额无息返还。
              </p>
              <p>
                ③竞拍人竞买成功后，携带相关资料到交易中心缴纳服务费，在交易中心主持下与出让方签订合同。
              </p>
              <p>
                ④成交人交易保证金作为出让金转入出让方账户，溢价部分向出让方补缴齐。
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="cityDetail.chargeStandard">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">收费标准</el-divider>
          </div>
        </div>
        <div
          style="text-align: left; display: block"
          v-html="chargeStandard"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTypeList } from '@/api/交易项目详情'
import { getNewsDetail, getNewslist } from '../api/mian'
import { cityDetail } from '../util/mainOption'

export default {
  props: ["detail", "backCardInfo"],
  data () {
    return {
      getDetailActive: 1, //项目模块展示
      showPhone: false,
      showRegisternum: false,
      dictList: {
        // 转出方类别
        "out_person_type": [],
        // 招标方式
        "invitation_type": [],
        // 单位
        "area_unit": [],
        // 农地权属
        "land_type": [],
        // 承包方式
        "job_type": [],
        // 项目类型
        "project_area_type": [],
        // 土地性质
        "tdxz_type": [],
        // 转出方式
        "out_type": [],
        // 支付方式
        "pay_type": [],
        // 出价幅度
        "floating_price": [],
        // 是否再次转出
        "yes_no": [],
      },
      imgList: [], //图片列表
      // 收费标准
      chargeStandard: "",
      // 报名方式 html
      applyWay: "",
    }
  },
  mounted () {
    getNewslist({
      number: '021',
      pageSize: 10,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.applyWay = res.data.data.content
        console.log("报名方式新闻详情", this.applyWay)
      })
    })
    if (cityDetail.chargeStandard) {
      getNewslist({
        number: '020',
        pageSize: 10,
        pageNum: 1,
        deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
      }).then(res => {
        res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
          console.log("收费标准新闻详情", res.data.data)
          this.chargeStandard = res.data.data.content
        })
      })
    }
    this.imgList = this.detail.imgList
    for (let dictTitle of Object.keys(this.dictList)) {
      getTypeList(dictTitle).then(res => {
        this.dictList[dictTitle] = res.data.data
      })
    }
  },
  methods: {
    checkShowPhone () {
      this.showPhone = !this.showPhone
    },
    checkShowRegisternum () {
      this.showRegisternum = !this.showRegisternum
    },
    // 获取字典值
    getDictValue (value, dictTitle) {
      if ((value !== 0 && value !== '0') && !value) return "暂无"
      return this.dictList[dictTitle].find((item) => item.dictValue == value) ? this.dictList[dictTitle].find((item) => item.dictValue == value).dictLabel : "暂无"
    },
  },
}
</script>

<style lang="scss" scoped>
.fengexian1 {
  margin: 30px 0 50px 0;
}

.el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.conent > div {
  margin: 10px 0;
}
.footerTitle {
  font-size: 36px;
  height: 15px;
  /* border: #67C23A 1px solid; */
  /* margin-bottom: 40px; */
  color: #f56c6c;
  /* list-style: armenian; */
}
.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}
.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
  cursor: pointer;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
  cursor: pointer;
}
.fengexian {
  margin-bottom: 40px;
}

.fengexian >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}
.tableBox {
  display: flex;
}
.left {
  width: 100%;
  text-align: left;
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
}
.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
  width: 50%;
}

.tet1 {
  min-width: 250px;
  max-width: 250px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tet2 {
  padding: 20px 20px;
  width: 685px;
  max-width: 685px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
}
table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}
</style>